var map = {
	"./img/login-logo.png": "./application/report/assets/img/login-logo.png",
	"./img/logo.png": "./application/report/assets/img/logo.png",
	"./img/white-logo.png": "./application/report/assets/img/white-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./application/report/assets sync recursive ^.*logo\\.png$";